import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    LinearProgress
} from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

export default function UpdateModal({ open, onUpdate, onDismiss, version, versionInfo }) {
    const [updating, setUpdating] = React.useState(false);

    const handleUpdate = async () => {
        setUpdating(true);
        await onUpdate();
    };

    return (
        <Dialog
            open={open}
            onClose={!updating ? onDismiss : undefined}
            maxWidth="sm"
            fullWidth
            disableEscapeKeyDown={updating}
        >
            <DialogTitle sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                bgcolor: '#1976d2',
                color: 'white'
            }}>
                <NewReleasesIcon />
                Nova Versão Disponível
            </DialogTitle>
            
            <DialogContent sx={{ mt: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center',
                        py: 2 
                    }}>
                        <SystemUpdateAltIcon sx={{ fontSize: 80, color: '#1976d2' }} />
                    </Box>
                    
                    <Typography variant="h6" align="center" gutterBottom>
                        Versão {version}
                    </Typography>
                    
                    <Typography variant="body1" align="center" color="text.secondary">
                        Uma nova versão do sistema está disponível com melhorias e correções.
                    </Typography>

                    {versionInfo?.features && versionInfo.features.length > 0 && (
                        <Box sx={{ 
                            bgcolor: '#e3f2fd', 
                            p: 2, 
                            borderRadius: 1,
                            mt: 1,
                            borderLeft: '4px solid #1976d2'
                        }}>
                            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                                ✨ Novidades nesta versão:
                            </Typography>
                            <Typography variant="body2" component="ul" sx={{ pl: 2, m: 0 }}>
                                {versionInfo.features.map((feature, index) => (
                                    <li key={index}>{feature}</li>
                                ))}
                            </Typography>
                        </Box>
                    )}
                    
                    <Box sx={{ 
                        bgcolor: '#f5f5f5', 
                        p: 2, 
                        borderRadius: 1,
                        mt: 1 
                    }}>
                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            O que será feito:
                        </Typography>
                        <Typography variant="body2" component="ul" sx={{ pl: 2, m: 0 }}>
                            <li>Limpeza de cache antigo</li>
                            <li>Atualização para nova versão</li>
                            <li>Aplicação das novas funcionalidades</li>
                            <li>Recarregamento automático do sistema</li>
                        </Typography>
                    </Box>

                    {updating && (
                        <Box sx={{ mt: 2 }}>
                            <Typography variant="body2" align="center" gutterBottom>
                                Atualizando...
                            </Typography>
                            <LinearProgress />
                        </Box>
                    )}
                </Box>
            </DialogContent>
            
            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button 
                    onClick={onDismiss} 
                    color="inherit"
                    disabled={updating}
                >
                    Atualizar Depois
                </Button>
                <Button 
                    onClick={handleUpdate} 
                    variant="contained" 
                    color="primary"
                    disabled={updating}
                    startIcon={<SystemUpdateAltIcon />}
                >
                    Atualizar Agora
                </Button>
            </DialogActions>
        </Dialog>
    );
}
